<template>
  <div>
    <div class="banner-business-menu"></div>
    <div data-v-249f9abc="" class="wrapper clearfix">
      <div data-v-249f9abc="" class="content clearfix">
        <div>
          <div data-v-24ee54cc="" class="side-nav">
            <div data-v-24ee54cc="" class="title">
              服务指南
            </div>
            <ul data-v-24ee54cc="" class="nav-list">
              <li data-v-24ee54cc="" :class="{current:current===0}" @click="current=0"><span data-v-24ee54cc="">营业网点</span><i data-v-24ee54cc="" class="el-icon-arrow-right"></i></li>
              <li data-v-24ee54cc="" :class="{current:current===1}" @click="current=1"><span data-v-24ee54cc="">常见问题</span><i data-v-24ee54cc="" class="el-icon-arrow-right"></i></li>
              <li data-v-24ee54cc="" :class="{current:current===2}" @click="current=2"><span data-v-24ee54cc="">水价标准</span><i data-v-24ee54cc="" class="el-icon-arrow-right"></i></li>
              <li data-v-24ee54cc="" :class="{current:current===3}" @click="current=3,currentPage1=1,pageSize1=15"><span data-v-24ee54cc="">政策法规</span><i data-v-24ee54cc="" class="el-icon-arrow-right"></i></li>
              <li data-v-24ee54cc="" :class="{current:current===4}" @click="current=4,currentPage2=1,pageSize2=15"><span data-v-24ee54cc="">业务指南</span><i data-v-24ee54cc="" class="el-icon-arrow-right"></i></li>
<!--              <li data-v-24ee54cc="" :class="{current:current===5}" @click="current=5"><span data-v-24ee54cc="">表格下载区</span><i data-v-24ee54cc="" class="el-icon-arrow-right"></i></li>-->
            </ul>
          </div>
          <div v-if="current===0" class="special_content">
            <div class="success_content1">
              <p class="suc_title1">营业网点</p>
            </div>
            <div class="collapse_style">
              <div role="tablist" aria-multiselectable="true" class="el-collapse">
                <div class="el-collapse-item">
                  <div role="tabpanel" aria-labelledby="el-collapse-head-9927" id="el-collapse-content-9927" class="el-collapse-item__wrap" data-old-padding-top="" data-old-padding-bottom=""
                       data-old-overflow="hidden" style="overflow: hidden;">
                    <div class="el-collapse-item__content">
                      <div v-if="Bussines.length" style="height: 360px; overflow-y: scroll;">
                        <div v-for="(item,index) in Bussines" :key="index">
                          <div class="top_style"><span class="locaux_style">{{item.title}}</span><span class="map_style" @click="showMap(item)">查看地图</span></div>
                          <div class="content_style">
                            <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAWCAYAAADwza0nAAAAAXNSR0IArs4c6QAAAg1JREFUOBF9U01LFWEUfs47oygR140h3KAiiqJWRULgvxDctXCTkCDkL5jfcHfSwl27Nv2ICi9BiyKZLK1NmRrWVet6Z+b0nHecr+6lA2fmfD3vec/HK6hTFDlMTU0jCG4hwyWIU0j2BWn6DoeHe4iirAiXQsD6+gR+Hs8Cco/B50u7Cep6/HTROreBxcU/ZsqBBuqdzEOza2b8D8UQfYaVlb7zQb3e3DBI+jyX3KDrzD5nFkGnMw2Vh5THyhBxb5Hoe6+HcpOH3i59Kqdw2ZMQGtwFsgoE2cSPvedsxKkP7nS2ABeyxhteFx1HJnd41exyeZoX0tclyHTWA9BWJ8EVAuW4boNILfuZ51+b4sjB6RteRUuwFb+21ip1k88akttcilA2JJ/fyQPOrl0GA9/YsI9eF73K/0zlk21MjD11fqCKbuXw0gwc7ntugPwmdbG0NMjnOI4trtfXBljVwbhBXL8k2TZT7lhePmKLX7Ix5S424r3C2jR4gdXV3xXQpNZkTPCOiSNJsxiTwafCV13FljfUV8yaFM7af8BsvrbCVgHNsr/PLWHXhogdfvyozGbuJtDeW8K5NrMO8lk3T2sCzXfxwiZr3a3CKB8cxJWeS8PAhYUUThho20RWxPWXXxwwDDRPIqxV+TrIOvhQBNf/o4G/du2q9oj7aLe/1wGFPBoYRQm35rNnu/oI+gszA8QEBXbVrQAAAABJRU5ErkJggg==" class="pic_style">
                            <span class="position_area">{{ item.location }}</span>
                          </div>
                          <div class="bottom_style">
                            <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAAAXNSR0IArs4c6QAAAvNJREFUOBGdVd1Lk2EUfz72ttKbnEETEZHosu/Al00Qb8KkbiJWlpuzz7ui2+iifyAI6iaL3KZmrCAiISqIFm4OKSq7FAqTpYUrb1Km7/s8/c6br85Nwzpwdr5/O8/ZeZ5xtgolk0n5q7Z2h+A8ypU6xoTwO2laT2rOk0rrWGUu9zEUCtml5bzU0Z/NbrdsO8o5P45YNfgneHoxbwtkFTjPtB6QUsZPmubYYswRKwBj6fQBwVg/49yH6FMU9aG7D3OGMU7ZmxYW6plSuxDvgNkGnka3HdFg8DnFiZYAezKZVkkgjE0B6FIkGLzvZOAjnk4fJb0zGHzo+hKZzAno18A0jtZIIPCMYmiIsbsjI3WS8x6oeSXEoWIwiuP414lJdwkA99DtYdh0/J6BVKqOYg6gx7YvwunXWp+OmuZbt8iV+CEmiF3blZGmpjeasbP4xpp5w7hAfpFIpRoAdg76ExzpsZtcLIXWNtdaFftcvTMQeAR9ELM7359O1wvm9UbhMPAtt92kUokuOAqsUr9r42R3oG/AuKICexaG8U0qNeomlEqAaYCu2iHlehh7DzGlgeVBYgOMdwXbnqXgaoQcmrWZGB5+6cS1pn18bRcKV7paWmao1uPx/MA59gD8D22sqEDdmvQKwVnM0qAM6GvmEuAnsE8XCpWQ7o2AukxYkcvLVrnmlbICd9CHWY4JnCWOlK2Y+O7y1PV5LM73ItOPthNCKRWDMc+FoNX5L8LSn0HhnNey4gLL+QXI3fgd2zD0I/+K6FxL1KK+u725ecK5KVidGwCaJGcsm923XtDE0NB+dHcL+TnLsm5SnQNIXULvAldjBoO9mUw7Bf9GTo4Qg8ipQkNdp9Ad5WNnl8l5vjjvhYf2bOn5sqWkN5EZSvmUbe/EkxbGaQ7C9R2zD4dN8wXFiVYAkgOg2wSuEAroeaIHdgacBxORvRlMdh+TMhZpbPwMfYnKAClS/BeAZQ7hpakhP368rxAP6C9gPBAYvcp52XX8De2DKTt7bdx8AAAAAElFTkSuQmCC" class="pic_style" style="margin-left: 0px;">
                            <span class="position_area" style="margin-top: 2px;">{{item.worktime}}</span>
                          </div>
                        </div>
                        <div>
                        </div>
                      </div>
                      <el-empty v-else></el-empty>
                    </div>
                  </div>
                  <!-- <div role="tabpanel" aria-labelledby="el-collapse-head-9927" id="el-collapse-content-9927" class="el-collapse-item__wrap" data-old-padding-top="" data-old-padding-bottom=""
                       data-old-overflow="" style="display: none;" aria-hidden="true">
                    <div class="el-collapse-item__content">
                      <div></div>
                    </div>
                  </div> -->
                </div>
                <!-- <div class="el-collapse-item">
                  <div role="tab" aria-controls="el-collapse-content-9960" aria-describedby="el-collapse-content-9960">
                    <div role="button" id="el-collapse-head-9960" tabindex="0" class="el-collapse-item__header">
                      分水自来水营业部
                      <i class="el-collapse-item__arrow el-icon-arrow-right"></i>
                    </div>
                  </div>
                  <div role="tabpanel" aria-labelledby="el-collapse-head-9960" id="el-collapse-content-9960" class="el-collapse-item__wrap" data-old-padding-top="" data-old-padding-bottom=""
                       data-old-overflow="" style="display: none;" aria-hidden="true">
                    <div class="el-collapse-item__content">
                      <div></div>
                    </div>
                  </div>
                </div> -->

              </div>
            </div>
          </div>
          <div v-if="current===1" data-v-40e3d77e="" class="main">
            <h1 data-v-40e3d77e="">常见问题</h1>
            <div data-v-40e3d77e="" class="message-box">
              <ul v-if="commonquetion.length" data-v-40e3d77e="" class="list border" style="height: auto;">
                <li data-v-40e3d77e="" class="between" style="margin-top: 5px; margin-bottom: 5px;" v-for="(item,index) in commonquetion" :key="index">
                  <span data-v-40e3d77e="" title="发现供水、排水井盖缺损应如何处理？" class="list-title"
                  @click="Question(item)">{{item.title}}</span>
                  <span data-v-40e3d77e="" class="date">{{ item.textTime | Date}}</span>
                </li>
              </ul>
              <el-empty v-else></el-empty>
              <!---->
            </div>
          </div>
          <div v-if="current===2" class="main">
            <h1>水价标准</h1>
            <div v-html="WaterPrice.text"></div>
          </div>
          <div v-if="current===3" data-v-40e3d77e="" class="main">
            <h1 data-v-40e3d77e="">政策法规</h1>
            <div v-if="Waterpolicy1.length" data-v-40e3d77e="" class="message-box">
              <ul data-v-40e3d77e="" class="list border" style="height: auto;">
                <li data-v-40e3d77e="" class="between" style="margin-top: 5px; margin-bottom: 5px;" v-for="(item,index) in Waterpolicy1" :key="index">
                  <span data-v-40e3d77e="" title="重磅！《桐庐县2021年深化“放管服”改革 优化营商环境重点任务清单》来了"
                        class="list-title" @click="policy(item)">{{item.title}}</span>
                  <span data-v-40e3d77e="" class="date">{{item.textTime | Date}}</span>
                </li>
              </ul>
              <el-pagination
                  @size-change="handleSizeChange1"
                  @current-change="handleCurrentChange1"
                  :current-page="currentPage1"
                  :page-sizes="[15, 30, 60, 90]"
                  :page-size="pageSize1"
                  layout="total, sizes, prev, pager, next, jumper"
                  :total="Waterpolicy.length">
              </el-pagination>
            </div>
            <el-empty v-else></el-empty>
          </div>
          <div v-if="current===4" data-v-40e3d77e="" class="main">
            <h1 data-v-40e3d77e="">业务指南</h1>
            <div v-if="BusinessGuide1.length" data-v-40e3d77e="" class="message-box">
              <ul data-v-40e3d77e="" class="list border" style="height: auto;">
                <li data-v-40e3d77e="" class="between" style="margin-top: 5px; margin-bottom: 5px;" v-for="(item,index) in BusinessGuide1" :key="index">
                  <span data-v-40e3d77e="" title="单位客户用水报装" class="list-title" @click="Guide(item)">{{ item.title }}</span>
                  <span data-v-40e3d77e="" class="date">{{item.textTime | Date}}</span>
                </li>
              </ul>
              <el-pagination
                  @size-change="handleSizeChange2"
                  @current-change="handleCurrentChange2"
                  :current-page="currentPage2"
                  :page-sizes="[15, 30, 60, 90]"
                  :page-size="pageSize2"
                  layout="total, sizes, prev, pager, next, jumper"
                  :total="BusinessGuide.length">
              </el-pagination>
            </div>
            <el-empty v-else></el-empty>
          </div>
          <business-aside/>
        </div>
      </div>
    </div>

<!--    地图弹窗-->
    <div class="Popup" v-if="showPop">
      <div class="Popup_top flex">
        <div class="p_top_title">地图</div>
        <div class="p_top_close" @click="showPop=false">X</div>
      </div>
<!--  地图组件-->
      <baidu-map class="map" :center="mapCenter[0]" :zoom="17" :scroll-wheel-zoom='true'>
        <bm-marker :position="mapCenter[0]" :dragging="true" @click="infoWindowOpen">
          <bm-info-window :position="mapCenter[0]"
                          :title="mapTitle" :show="infoWindow.show"
                          @close="infoWindowClose" >
            <div class="map_local flex">
<!--              class="map_local flex"-->
              <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAWCAYAAADwza0nAAAAAXNSR0IArs4c6QAAAg1JREFUOBF9U01LFWEUfs47oygR140h3KAiiqJWRULgvxDctXCTkCDkL5jfcHfSwl27Nv2ICi9BiyKZLK1NmRrWVet6Z+b0nHecr+6lA2fmfD3vec/HK6hTFDlMTU0jCG4hwyWIU0j2BWn6DoeHe4iirAiXQsD6+gR+Hs8Cco/B50u7Cep6/HTROreBxcU/ZsqBBuqdzEOza2b8D8UQfYaVlb7zQb3e3DBI+jyX3KDrzD5nFkGnMw2Vh5THyhBxb5Hoe6+HcpOH3i59Kqdw2ZMQGtwFsgoE2cSPvedsxKkP7nS2ABeyxhteFx1HJnd41exyeZoX0tclyHTWA9BWJ8EVAuW4boNILfuZ51+b4sjB6RteRUuwFb+21ip1k88akttcilA2JJ/fyQPOrl0GA9/YsI9eF73K/0zlk21MjD11fqCKbuXw0gwc7ntugPwmdbG0NMjnOI4trtfXBljVwbhBXL8k2TZT7lhePmKLX7Ix5S424r3C2jR4gdXV3xXQpNZkTPCOiSNJsxiTwafCV13FljfUV8yaFM7af8BsvrbCVgHNsr/PLWHXhogdfvyozGbuJtDeW8K5NrMO8lk3T2sCzXfxwiZr3a3CKB8cxJWeS8PAhYUUThho20RWxPWXXxwwDDRPIqxV+TrIOvhQBNf/o4G/du2q9oj7aLe/1wGFPBoYRQm35rNnu/oI+gszA8QEBXbVrQAAAABJRU5ErkJggg==">
              <span v-text="infoWindow.contents" style="margin-left: 5px;"></span>
            </div>
            <div class="map_local flex" style="color: #064a93">
<!--              class="map_local flex"-->
              <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAAAXNSR0IArs4c6QAAAvNJREFUOBGdVd1Lk2EUfz72ttKbnEETEZHosu/Al00Qb8KkbiJWlpuzz7ui2+iifyAI6iaL3KZmrCAiISqIFm4OKSq7FAqTpYUrb1Km7/s8/c6br85Nwzpwdr5/O8/ZeZ5xtgolk0n5q7Z2h+A8ypU6xoTwO2laT2rOk0rrWGUu9zEUCtml5bzU0Z/NbrdsO8o5P45YNfgneHoxbwtkFTjPtB6QUsZPmubYYswRKwBj6fQBwVg/49yH6FMU9aG7D3OGMU7ZmxYW6plSuxDvgNkGnka3HdFg8DnFiZYAezKZVkkgjE0B6FIkGLzvZOAjnk4fJb0zGHzo+hKZzAno18A0jtZIIPCMYmiIsbsjI3WS8x6oeSXEoWIwiuP414lJdwkA99DtYdh0/J6BVKqOYg6gx7YvwunXWp+OmuZbt8iV+CEmiF3blZGmpjeasbP4xpp5w7hAfpFIpRoAdg76ExzpsZtcLIXWNtdaFftcvTMQeAR9ELM7359O1wvm9UbhMPAtt92kUokuOAqsUr9r42R3oG/AuKICexaG8U0qNeomlEqAaYCu2iHlehh7DzGlgeVBYgOMdwXbnqXgaoQcmrWZGB5+6cS1pn18bRcKV7paWmao1uPx/MA59gD8D22sqEDdmvQKwVnM0qAM6GvmEuAnsE8XCpWQ7o2AukxYkcvLVrnmlbICd9CHWY4JnCWOlK2Y+O7y1PV5LM73ItOPthNCKRWDMc+FoNX5L8LSn0HhnNey4gLL+QXI3fgd2zD0I/+K6FxL1KK+u725ecK5KVidGwCaJGcsm923XtDE0NB+dHcL+TnLsm5SnQNIXULvAldjBoO9mUw7Bf9GTo4Qg8ipQkNdp9Ad5WNnl8l5vjjvhYf2bOn5sqWkN5EZSvmUbe/EkxbGaQ7C9R2zD4dN8wXFiVYAkgOg2wSuEAroeaIHdgacBxORvRlMdh+TMhZpbPwMfYnKAClS/BeAZQ7hpakhP368rxAP6C9gPBAYvcp52XX8De2DKTt7bdx8AAAAAElFTkSuQmCC" class="pic_style">
              <span v-text="infoWindow.worktime" style="margin-left: 5px;"></span>
            </div>
          </bm-info-window>
        </bm-marker>
      </baidu-map>
    </div>
<!--    常见问题弹窗-->
    <div class="QuestionPop"  v-if="showQuestion">
      <div class="Popup_top flex">
        <div class="p_top_title">常见问题</div>
        <div class="p_top_close" @click="showQuestion=false">X</div>
      </div>
      <div v-html="questionNotic"></div>
    </div>
<!--    政策法规弹窗-->
    <div class="QuestionPop"  v-if="showWaterpolicy">
      <div class="Popup_top flex">
        <div class="p_top_title">政策信息</div>
        <div class="p_top_close" @click="showWaterpolicy=false">X</div>
      </div>
      <div v-html="WaterpolicyNotic"></div>
    </div>
<!--    业务指男弹窗-->
    <div class="GuidePop"  v-if="showbusinessGuide">
      <div class="Popup_top flex">
        <div class="p_top_title">业务指南</div>
        <div class="p_top_close" @click="showbusinessGuide=false">X</div>
      </div>
      <div v-html="BusinessGuideNotic"></div>
    </div>
  </div>
</template>

<script>
import businessAside from '../components/aside'
import http from "../http";
//引入element组件库
import ElementUI from "element-ui";
import Vue from "vue";
Vue.use(ElementUI);
export default {
  data() {
    return {
      current: 0,
      Bussines:[],
      commonquetion:[],
      Waterpolicy:[],
      WaterPrice:[],
      BusinessGuide:[],
      showPop:false,
      showQuestion:false,
      showWaterpolicy:false,
      showbusinessGuide:false,
      questionNotic:'',
      WaterpolicyNotic:'',
      BusinessGuideNotic:'',
      mapCenter:[],
      mapTitle:'',
      infoWindow: {
        show: true,
        contents: '',
        worktime:''
      },
      currentPage1:1,
      currentPage2:1,
      pageSize1:15,
      pageSize2:15
    }
  },
  components: {
    businessAside,
  },
  filters: {
    // 返回一个日期  年-月-日
    Date(val) {
      return val.slice(0, 10);
    },
  },
  methods:{
    async getBusiness() {
      try {
        const res = await http.getBusiness();
        // console.log("5555666", res);
        this.Bussines = res;
        // console.log(this.Bussines, "++++++++");
        // console.log(this.showid);
        // this.nowData = this.SwNews.filter((r) => r.id == this.showid);
        // console.log(this.nowData);
      } catch (ex) {
        console.log(ex);
      }
    },
    //
    async getQuestion(){
      try {
        const res = await http.getQuestion();
        // console.log("常见问题", res);
        res.forEach(r=>{
          r.data.forEach(item=>{
            this.commonquetion.push(item)
          })
        })
        // this.commonquetion = res;
        // console.log('common',this.commonquetion)
      } catch (ex) {
        console.log(ex);
      }
    },
    //
    async getWaterpolicy(){
      try {
        const res = await http.getWaterpolicy();
        // console.log("用水政策", res);
        res.forEach(r=>{
          r.data.forEach(item=>{
            this.Waterpolicy.push(item)
          })
        })
        // console.log('Waterpolicy',this.Waterpolicy)
      } catch (ex) {
        console.log(ex);
      }
    },
    //
    async getWaterPrice(){
      try {
        const res = await http.getWaterPrice();
        // console.log("水价信息", res);
        this.WaterPrice = res[0]
        // res.forEach(r=>{
        //   r.data.forEach(item=>{
        //     this.Waterpolicy.push(item)
        //   })
        // })
        // console.log('Waterpolicy',this.Waterpolicy)
      } catch (ex) {
        console.log(ex);
      }
    },
    //
    async getBusinessGuide(){
      try {
        const res = await http.getBusinessGuide();
        console.log("用水政策", res);
        this.BusinessGuide = res
        // console.log('BusinessGuide',this.BusinessGuide)
      } catch (ex) {
        console.log(ex);
      }
    },
  //  显示地图
    showMap(list){
      this.showPop = true
      this.infoWindow.show = true
      this.mapCenter = []
      // console.log(list)
      // console.log(list.businessLocation.split('|'))
      let Arr = list.businessLocation.split('|')
      this.mapCenter.push({
        lat:parseFloat(Arr[1]),
        lng:parseFloat(Arr[0])
      })
      this.infoWindow.contents = list.location
      this.infoWindow.worktime = list.worktime
      this.mapTitle = list.title
      // console.log(this.mapCenter)
    },
    Question(list){
      this.showQuestion = true
      this.questionNotic = list.text
    },
    policy(list){
      this.showWaterpolicy = true
      this.WaterpolicyNotic = list.text
    },
    Guide(list){
      this.showbusinessGuide = true
      this.BusinessGuideNotic = list.text
    },
  //  关闭信息框
    infoWindowClose () {
      this.infoWindow.show = false
    },
    infoWindowOpen () {
      this.infoWindow.show = true
    },
    handleCurrentChange1(val){
      // console.log(`第${val}页`);
      this.currentPage1 = val;
    },
    handleCurrentChange2(val){
      // console.log(`第${val}页`);
      this.currentPage2 = val
    },
    handleSizeChange1(val){
      // console.log(`当前页: ${val}`);
      this.pageSize1 = val;
      this.currentPage1 = 1
    },
    handleSizeChange2(val){
      // console.log(`当前页: ${val}`);
      this.pageSize2 = val
      this.currentPage2 = 1
    }
  },
  computed:{
    Waterpolicy1(){
      return this.Waterpolicy.slice((this.currentPage1 - 1) * this.pageSize1, this.currentPage1 * this.pageSize1);
    },
    BusinessGuide1(){
      return this.BusinessGuide.slice((this.currentPage2 - 1) * this.pageSize2, this.currentPage2 * this.pageSize2);
    }
  },
  created(){
    let active = this.$route.params.active
    if(active){
        this.current = parseInt(active)
    }
    
  },
  mounted() {
    this.getBusiness()
    this.getQuestion()
    this.getWaterpolicy()
    this.getWaterPrice()
    this.getBusinessGuide()
  }
}
</script>

<style>
#tb td {
  text-align: center;
  vertical-align: middle;
  padding: 10px 0;
}
.flex{
  display: flex;
}
.Popup{
  width: 900px;
  height: 900px;
  position: absolute;
  top: 100px;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
  background-color: white;
  z-index: 999;
  padding: 20px;
  box-shadow: 0 0 10px #ccc;
}
.p_top_title{
  margin: 0px auto;
  font-size: 18px;
  font-weight: bold;
  letter-spacing: 10px;
}
.p_top_close:hover{
  color: #1471d6;
  cursor: pointer;
}
.map{
  width: 800px;
  height: 800px;
  margin: 20px auto;
}
.map_local{
  align-items: center;
  margin-top: 10px;
}
.QuestionPop{
  width: 1100px;
  height: 900px;
  position: absolute;
  top: 100px;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
  background-color: white;
  z-index: 999;
  padding: 20px;
  overflow-y: scroll;
  box-shadow: 0 0 10px #ccc;
}
.GuidePop{
  width: 1200px;
  height: 900px;
  position: absolute;
  top: 100px;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
  background-color: white;
  z-index: 999;
  padding: 20px;
  overflow-y: scroll;
  box-shadow: 0 0 10px #ccc;
}
.wrapper {
  width: 1230px;
  margin: 0 auto;
}
</style>